// httpClient.js
import axios from 'axios';
const PROD_BOT = 'https://bot.cloobot.ai/uibot'
// const PROD_BOT = 'http://quote.cloobot.ai:5006'
// const PROD_BOT = 'http://quote.cloobot.ai:5008'
// const PROD_BOT = 'http://quote.cloobot.ai:5012'
// const PROD_BOT = 'http://quote.cloobot.ai:5024'
// const PROD_BOT = 'http://20.198.93.27:5012'
// const PROD_BOT = 'http://74.225.136.45:5008'

const botHttpClient = axios.create({
  baseURL: PROD_BOT, // Set your API base URL
});


export default botHttpClient;